import { useEffect } from "react";
import { useAppDispatch } from "../redux/store";
import { setNow } from "../redux/timeSlice";

export function useNow() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setNow()); // initial

    // Calculate delay to next sharp second
    const now = Date.now();
    const nextSecond = Math.ceil(now / 1000) * 1000;
    const delayToNextSecond = nextSecond - now;

    // Set timeout for the first dispatch at the next sharp second
    const timeoutId = setTimeout(() => {
      dispatch(setNow());

      // Then set up regular interval for subsequent seconds
      // Store interval ID for cleanup
      (timeoutId as any).intervalId = setInterval(() => {
        dispatch(setNow());
      }, 1000);
    }, delayToNextSecond);

    return () => {
      clearTimeout(timeoutId);
      if ((timeoutId as any).intervalId) {
        clearInterval((timeoutId as any).intervalId);
      }
    };
  }, [dispatch]);
}
